<template>
    <v-card flat>
        <v-card-text>
            <v-card-title>Customer</v-card-title>
            <v-row dense>
                <v-col cols="12" sm="4">
                    <row-item label="Customer:">
                        <label v-if="customer.middleName">{{customer.firstName}} {{customer.middleName}} {{customer.lastName}}</label>
                        <label v-else>{{customer.firstName}} {{customer.lastName}}</label>
                    </row-item>
                </v-col>
                <v-col cols="6" sm="4">
                    <row-item label="Mobile No : " :value="customer.mobileNo.toString()"></row-item>
                </v-col>
                <v-col cols="6" sm="4">
                    <row-item v-if="customer.email" label="E-Mail : " :value="customer.email"></row-item>
                </v-col>
            </v-row>
            <customer-order :customerId="$route.params.id"></customer-order>
            <reward-logs :rewardLogs="reward.rewardLogs" :totalRewardPoint="reward.totalRewardPoint"></reward-logs>
        </v-card-text>
        <v-flex text-right>
            <v-btn @click="$router.go(-1)" class="ma-2" :style="theme">Back</v-btn>
        </v-flex>
    </v-card>
</template>

<script>
import RowItem from '@/components/RowItem'
import appConstants from '@/utils/appConstants'
import CustomerOrder from '@/components/CustomerOrder'
import RewardLogs from '@/components/RewardLogs'
export default {
    components: {
        RowItem,
        CustomerOrder,
        RewardLogs
    },
    data() {
        return {
            customer: {
                firstName: "",
                middleName: "",
                lastName: "",
                mobileNo: "",
                email: ""
            },
            reward: {
                totalRewardPoint: 0,
                rewardLogs: []
            },
            items: [],
        }
    },
    mounted() {
        this.initComponent();
    },
    methods: {
        async initComponent() {
            this.id = this.$route.params.id
            this.customer = await this.getItem(appConstants.CUSTOMERS_API + "/" + this.id)
            let rewards = await this.getItem(appConstants.REWARD_API + "/user/" + this.id)
            if (rewards.length > 0)
                this.reward = rewards[0]
        },
    }
}
</script>
